module.exports = __webpack_public_path__ + "img/stone.2b5d3878.png";